<template>
  <div class="relative f-col" :class="{ 'h-full': !images }">
    <base-picture v-if="images" v-bind="images" class="grow" fit="cover" :lazy />
    <div
      v-style:c="titleColor"
      class="flex justify-center"
      :class="[
        titleStyle,
        titlePosition === 'below-left' ? 'text-left' : 'text-center',
        titlePosition === 'middle' ? 'items-center' : 'items-end',
        { 'absolute-0': images && isOverlay, 'p-4': isOverlay },
      ]"
    >
      <p v-style:bg="backdrop" :class="isOverlay ? 'p-2 md:p-4' : 'w-full px-4 py-2'">
        <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
        <span v-else>{{ title }}</span>
      </p>
    </div>
    <base-link
      v-if="target?.url"
      :aria-label="title"
      class="absolute-0"
      :data-cta="target.delocalizedTracking"
      :to="target.url"
      @click="handleClick"
    />
  </div>
</template>

<script lang="ts" setup>
import type { SectionProvider } from '#content/contexts/section'
import type { CategoryCardContent } from '#types/components/cms/category-card'
import { ParentPromotionTrackingKey } from '#content/contexts/promotionTracking'
import { SectionContextKey } from '#content/contexts/section'

const { content, index = 0 } = defineProps<{ content: CategoryCardContent, index?: number }>()

const { getMedia } = useCms()
const { lazy } = inject(SectionContextKey, {} as SectionProvider)

const { title, titleHtml, titleStyle, titleColor, titlePosition, target, media, backdrop } = content
const { images } = getMedia(media)

const isOverlay = !titlePosition?.includes('below')

const { parentHandlePromotionClick } = inject(ParentPromotionTrackingKey, {})
const handleClick = () => parentHandlePromotionClick && parentHandlePromotionClick(`card${index + 1}`)
</script>
